import { useEffect, useState } from "react";
import LavorisService from "../../services/LavorisService";
import { getProfileResponseService } from "../../services/Company/Company.type"
import { PhoneNumber } from "../../utils/phoneNumber";
import { useSelector } from "react-redux";
import { RootState } from "../../store/combineReducer";
import {
  getDisplayClientCode,
  isFranchiseTenant,
} from "../../utils/franchise/franchiseAbsenteeismMenu";

const DatosEmpresa = () => {
  const LavorisInstance = LavorisService.getInstance();
  const currentCompany = useSelector((state: RootState) => state.user.currentCompany || state.user.companies[0]);
  const franchiseState = useSelector((state: RootState) => state.franchise);
  const isFranchise = isFranchiseTenant(franchiseState);
  const [data, setData] = useState<getProfileResponseService>();
  const [emails, setEmails] = useState<any>()

  useEffect(() => {
    const getCompanyProfile = async () => {
      try {
        const companyProfile = await LavorisInstance.CompanyServices.getCompanyProfile(currentCompany.id);
        if (companyProfile) {
          setData(companyProfile);
          if (companyProfile?.managerId) {
            const compEmails = await LavorisInstance.CompanyServices.getCompanyEmails(companyProfile.managerId)
            setEmails(compEmails)
          }
        }
      } catch (e) {
        console.log(e);
      }
    };
    getCompanyProfile();
  }, []);

  const aliasFormatter = (alias: string | undefined) => {
    if (alias) {
      const formattedAlias = alias.split("_").join(" ").toLocaleLowerCase();
      return formattedAlias
    }
    return "N/A"
  }
console.log(data);
  return (
    <div className="company-data">
      <div className="container-fluid">
        <div className="row g-4">

          {/* Fila 1: Datos de la empresa */}
          <div className="col-12 col-lg-6">
            <div className="company-section">
              <h3 className="section-title">Datos de la empresa</h3>

              <div className="company-field">
                <label>Razón social</label>
                <span>{data?.socialReason || "N/A"}</span>
              </div>

              <div className="company-field">
                <label>CUIT</label>
                <span>{data?.cuit || "N/A"}</span>
              </div>

              <div className="company-field">
                <label>Rubro de la empresa</label>
                <span>{data?.heading || "N/A"}</span>
              </div>

              <div className="company-field">
                <label>Nombre de Fantasía</label>
                <span>{data?.fantasyName || "N/A"}</span>
              </div>

              <div className="company-field">
                <label>Condición frente al IVA</label>
                <span>{data?.ivaCondition || "N/A"}</span>
              </div>

              <div className="company-field">
                <label>ART</label>
                <span className="text-capitalize">{aliasFormatter(data?.ART)}</span>
              </div>
            </div>
          </div>

          {/* Fila 1: Datos de contacto */}
          <div className="col-12 col-lg-6">
            <div className="company-section">
              <h3 className="section-title">Datos de contacto</h3>

              <div className="company-field">
                <label>Provincia</label>
                <span>{data?.province || "N/A"}</span>
              </div>

              <div className="company-field">
                <label>Ciudad</label>
                <span>{data?.location || "N/A"}</span>
              </div>

              <div className="company-field">
                <label>Dirección</label>
                <span>{data?.residence || "N/A"}</span>
              </div>

              <div className="company-field">
                <label>Código Postal</label>
                <span>{data?.postalCode || "N/A"}</span>
              </div>

              <div className="company-field">
                <label>Teléfono</label>
                {data?.phoneNumber && PhoneNumber(data?.phoneNumber) ? (
                  <a href={`tel:${data.phoneNumber}`}>{data.phoneNumber}</a>
                ) : (
                  <span>N/A</span>
                )}
              </div>

              <div className="company-field">
                <label>Email</label>
                {data?.email ? (
                  <a href={`mailto:${data.email}`}>{data.email}</a>
                ) : (
                  <span>N/A</span>
                )}
              </div>
            </div>
          </div>

          {/* Fila 2: Datos de facturación */}
          <div className="col-12">
            <div className="company-section">
              <h3 className="section-title">Datos de facturación</h3>

              <div className="row g-4">
                <div className="col-12 col-lg-6">
                  <div className="company-field">
                    <label>Código Cliente</label>
                    <span>
                      {isFranchise
                        ? getDisplayClientCode(data, true)
                        : (data?.managerId || "N/A")}
                    </span>
                  </div>

                  <div className="company-field">
                    <label>Facturar a</label>
                    <span>{data?.billedTo || "N/A"}</span>
                  </div>

                  <div className="company-field">
                    <label>Emails Facturación</label>
                    {emails?.length > 0 ? (
                      <div className="email-list">
                        {emails?.map((email: any, i: any) => (
                          <span key={i} className="email-item">{email}</span>
                        ))}
                      </div>
                    ) : (
                      <span>N/A</span>
                    )}
                  </div>

                  <div className="company-field">
                    <label>Portal web para la carga y gestión de facturas</label>
                    {data?.billing_web_url ? (
                      <a href={data.billing_web_url} target="_blank" rel="noopener noreferrer">
                        {data.billing_web_url}
                      </a>
                    ) : (
                      <span>N/A</span>
                    )}
                  </div>

                  <div className="company-field">
                    <label>Necesita Orden de compra o Nota de pedido</label>
                    <span>{data?.purchase_order || "N/A"}</span>
                  </div>

                  <div className="company-field">
                    <label>Email de cuentas a pagar</label>
                    {data?.account_payable_email ? (
                      <a href={`mailto:${data.account_payable_email}`}>{data.account_payable_email}</a>
                    ) : (
                      <span>N/A</span>
                    )}
                  </div>
                </div>

                <div className="col-12 col-lg-6">
                  <div className="company-field">
                    <label>Forma de Pago</label>
                    <span>{data?.paymentMethod || "N/A"}</span>
                  </div>

                  <div className="company-field">
                    <label>Plazo de Pago</label>
                    <span>{data?.paymentDeadline || "N/A"}</span>
                  </div>

                  <div className="company-field">
                    <label>Ciclo de Facturación</label>
                    <span>{data?.invoiceDate || "N/A"}</span>
                  </div>

                  <div className="company-field d-none">
                    <label>Inicio del Ciclo</label>
                    <span>{data?.billingStartDate || "N/A"}</span>
                  </div>

                  <div className="company-field d-none">
                    <label>Cantidad de Períodos</label>
                    <span>{data?.numberOfPeriods || "N/A"}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DatosEmpresa;